import { useTranslation } from 'react-i18next';
import {
  UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';

const languages: Array<{ code: string; label: string; flag: string }> = [
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'en', label: 'English',  flag: '🇬🇧' },
  // Aggiungere qui altre lingue in futuro:
  // { code: 'fr', label: 'Français', flag: '🇫🇷' },
  // { code: 'de', label: 'Deutsch',  flag: '🇩🇪' },
  // { code: 'es', label: 'Español',  flag: '🇪🇸' },
];

/**
 * SP-7a — selettore lingua nell'header.
 * Persistenza in localStorage via i18next-browser-languagedetector
 * (chiave configurata in src/i18n/index.ts → `vp-language`).
 */
export function LanguageSwitcher() {
  const { i18n, t } = useTranslation('shell');
  const currentCode = (i18n.language || 'it').split('-')[0];
  const current = languages.find((l) => l.code === currentCode) ?? languages[0];

  return (
    <UncontrolledDropdown>
      <DropdownToggle
        tag="button"
        type="button"
        className="btn btn-icon btn-sm btn-ghost-secondary d-inline-flex align-items-center gap-1"
        aria-label={t('header.language')}
        title={t('header.language')}
      >
        <span aria-hidden="true">{current.flag}</span>
        <span className="d-none d-md-inline small fw-semibold">{current.code.toUpperCase()}</span>
      </DropdownToggle>
      <DropdownMenu end>
        {languages.map((lang) => (
          <DropdownItem
            key={lang.code}
            active={lang.code === currentCode}
            onClick={() => { void i18n.changeLanguage(lang.code); }}
          >
            <span className="me-2" aria-hidden="true">{lang.flag}</span>
            {lang.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}
